export default __webpack_public_path__ + "static/media/browserSearch.01450f96.svg";